export enum CustomerType {
  Service = 'SERVICE',
  Saas = 'SAAS'
}
